import React from 'react';

interface StatusBadgeProps {
  active: boolean;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ active }) => {
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider border ${
      active 
        ? "bg-emerald-500/10 text-emerald-400 border-emerald-500/20" 
        : "bg-red-500/10 text-red-400 border-red-500/20"
    }`}>
      <span className={`w-1.5 h-1.5 rounded-full ${active ? "bg-emerald-500 animate-pulse" : "bg-red-500"}`} />
      {active ? "Active" : "Banned"}
    </span>
  );
};

export default StatusBadge;